import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import QuestionHelp from '../question/QuestionHelp';
import './radio.scss';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';

type RadioOption = {
    label: string;
    value: string;
    iconSrc?: string | null;
    iconAlt?: string;
};

export default function Radio(props: any) {

    const getSelectedRadioValue = () => {
        const selectedOption = props.options?.find((opt: any) => opt.selected);

        if (selectedOption) {
            return selectedOption.value.toString();
        }

        return props.question.answer;
    };

    const [question, setQuestion] = useState(props.question);
    const [radioValue, setRadioValue] = useState(getSelectedRadioValue());

    const hasCustomOptions = Array.isArray(props.options) && props.options.length > 0;

    const optionsToRender: RadioOption[] = hasCustomOptions
        ? props.options.map((opt: any): RadioOption => ({
            label: opt.label ?? opt.text ?? opt.name,
            value: (opt.value).toString(),
            iconSrc: opt.iconSrc ?? null,
            iconAlt: opt.iconAlt ?? ""
        }))
        : [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' }
        ];

    const isBooleanRadio =
        optionsToRender.length === 2 &&
        optionsToRender.some(opt => opt.label.toLowerCase() === 'yes') &&
        optionsToRender.some(opt => opt.label.toLowerCase() === 'no');

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );


    useEffect(() => {
        const isOtherOption = radioValue === "__OTHER__";

        if (!isOtherOption) {
            question.answer = radioValue;
            setQuestion(question);
        }
        props.showConditionQuestions(props.question.questionSetQuestion.questionID, radioValue);

        if (props.isRepeatable && !isOtherOption) {
            props.updateRepeatableAnswer(radioValue);
        }

        if ((props.questionIdPosition.split('|').length - 1) === 1) {
            let questionIdPositionItems = props.questionIdPosition.split('|');
            let parentID = questionIdPositionItems[0].split('-')[0];
            let childID = questionIdPositionItems[1].split('-')[0];
            let childIndex = questionIdPositionItems[1].split('-')[1];

            props.showConditionalChildren(parentID, radioValue, childID, childIndex);
        }

        props.resetCoverValidation();

    }, [radioValue]);

    const updateAnswer = (answer: string) => {
        tracking(Action.SAVE_QUESTIONS, props.question.questionSetQuestion.questionID);

        //Inject the answer directly into the prop object so logic e.g. other questions with enablement criteria relying on
        //this question can read it immidiately to prevent them using a stale (non-updated) state
        props.question.answer = answer;
        props.question.validationFail = false;

        setRadioValue(answer);

        

    }

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>
                    {question.questionSetQuestion.text}
                </label>
                <br />
                {optionsToRender.map((opt: any) => {
                    const buttonClasses = classNames({
                        'radio-btn': true,
                        'has-icon': !!opt.iconSrc,
                        'validation-fail': question.validationFail,
                        'selected': radioValue === opt.value,
                        'radio-select-bool': isBooleanRadio,
                        'radio-select': !isBooleanRadio
                    });

                    return (
                        <button
                            key={opt.value}
                            className={buttonClasses}
                            onClick={() => updateAnswer(opt.value)}
                            type="button"
                        >
                            {opt.iconSrc && (
                                <img
                                    className="radio-btn-icon"
                                    src={opt.iconSrc}
                                    alt={opt.iconAlt}
                                    aria-hidden={opt.iconAlt ? undefined : true}
                                />
                            )}

                            <span className="radio-btn-label">{opt.label}</span>
                        </button>
                    );
                })}

                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {question.validationFail && (!props.isRepeatable || question.answer === "") &&
                    <ValidationMessage question={question} overrideMessage="Please select an option" />}
                <br />
            </div>
        </>

    )
}